import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from "./supportedLanguages";

import enCommon from "../locales/en/common.json";
import enAuth from "../locales/en/auth.json";
import enSettings from "../locales/en/settings.json";
import enTrips from "../locales/en/trips.json";
import enNav from "../locales/en/nav.json";
import enChat from "../locales/en/chat.json";
import enTripPage from "../locales/en/tripPage.json";
import enLegal from "../locales/en/legal.json";
import enHelp from "../locales/en/help.json";
import enNewsletter from "../locales/en/newsletter.json";
import enLanding from "../locales/en/landing.json";

import deCommon from "../locales/de/common.json";
import deAuth from "../locales/de/auth.json";
import deSettings from "../locales/de/settings.json";
import deTrips from "../locales/de/trips.json";
import deNav from "../locales/de/nav.json";
import deChat from "../locales/de/chat.json";
import deTripPage from "../locales/de/tripPage.json";
import deLegal from "../locales/de/legal.json";
import deHelp from "../locales/de/help.json";
import deNewsletter from "../locales/de/newsletter.json";
import deLanding from "../locales/de/landing.json";

const supportedLngs = SUPPORTED_LANGUAGES.map((l) => l.code);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        auth: enAuth,
        settings: enSettings,
        trips: enTrips,
        nav: enNav,
        chat: enChat,
        tripPage: enTripPage,
        legal: enLegal,
        help: enHelp,
        newsletter: enNewsletter,
        landing: enLanding,
      },
      de: {
        common: deCommon,
        auth: deAuth,
        settings: deSettings,
        trips: deTrips,
        nav: deNav,
        chat: deChat,
        tripPage: deTripPage,
        legal: deLegal,
        help: deHelp,
        newsletter: deNewsletter,
        landing: deLanding,
      },
    },
    supportedLngs,
    fallbackLng: DEFAULT_LANGUAGE,
    defaultNS: "common",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["path", "localStorage", "navigator"],
      lookupFromPathIndex: 0,
      lookupLocalStorage: "daynav.language",
      caches: ["localStorage"],
    },
  });

export { i18n };
